// extracted by mini-css-extract-plugin
export default {"container":"DesktopLayout_container__lTQXk","title":"DesktopLayout_title__qxbfN","description":"DesktopLayout_description__qAUUX"};